import capitalizeFilter from '../../../filters/capitalize-filter';
import windowService from '../../../services/windowService';
import { NextAction } from '../models/nextAction';

export default function getTrainingAction(
  type: 'course' | 'pathway',
  trainingId: string,
  trainingProgress?: NextAction
) {
  const progressType = trainingProgress?.progress?._type;
  const assigned = !!trainingProgress?.instanceId;
  const route = assigned
    ? `#/training-steps/${trainingProgress.instanceId}?stepId=${trainingProgress.stepId}${
        type === 'pathway' ? '&isWorkflow=true' : ''
      }`
    : `#/add-to-your-training/${trainingId}?noLogout=1&reassign=1`;

  const handleRedirect = () => {
    windowService.redirectTo(route);
  };

  return {
    trainingActionText:
      (progressType === 'Started' ? 'Resume' : progressType === 'Finished' ? 'View' : 'Start') +
      ' ' +
      capitalizeFilter(type),
    handleRedirect,
  };
}
